// 商品画像の切り替えslick使用
$(function () {
    $slide = $(".product__media-list");
    $navigation = $(".product_thumb li");

    $slide.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="prev slide_btn"><span></span></div>',
        nextArrow: '<div class="next slide_btn"><span></span></div>',
        fade: true,
    });
    $navigation.each(function (index) {
        //サムネイルに連番付与属性
        $(this).attr("data-number", index);
    });
    $navigation.eq(0).addClass("current"); //1枚をオーバーレイ

    $navigation.on("click", function () {
        //サムネイルクリック時イベント
        var number = $(this).attr("data-number");
        $slide.slick("slickGoTo", number, true);
        $(this).siblings().removeClass("current");
        $(this).addClass("current");
    });
});

window.addEventListener("DOMContentLoaded", () => {
    // お支払いや送料の内部リンク、クリック時にタブを開く
    shippingFeeLink();

    // 商品Noを表示する
    const productFormVariant = document.getElementById("productFormVariant");
    displayProductSku(productFormVariant.value);

    // 商品のバリエーションが変わったら商品Noの表示を切り替える
    changeProductSku();
});

const shippingFeeLink = () => {
    const shippingFeeLink = document.getElementById("shippingFeeLink");
    const shippingFeeTab = document.getElementById("product_tab03");
    shippingFeeLink.addEventListener("click", () => {
        shippingFeeTab.checked = true;
    });
};

const changeProductSku = () => {
    // variantのid
    const productFormVariant = document.getElementById("productFormVariant");
    // フォームのidが変わったら商品Noを書き換える
    productFormVariant.addEventListener("change", () => {
        displayProductSku(productFormVariant.value);
    });
};

// 商品idから商品Noを表示する関数
const displayProductSku = (id) => {
    // 商品Noを表示するタグ
    const productSku = document.getElementById("productSku");
    const productVariantData = JSON.parse(productSku.dataset.sku);

    productVariantData.forEach((data) => {
        if (data.id == id) {
            // 商品のvariantデータ
            productSku.textContent = `：${data.sku}`;
        }
    });
};
